<template>
  <v-col cols="12" sm="12" md="4">
    <v-card outlined>
      <v-card-title color="blue" class="pb-1">
        <div class="overline" style="color: #d53f8c">{{ help.type }}</div>
      </v-card-title>
      <v-card-text class="py-0">
        <div v-if="help.type == 'quote'" class>
          <blockquote
            class="headline text-purple font-weight-bold font-italic"
            style="overflow: visible; white-space:normal; line-height: 1.4rem"
          >
            <!-- <v-icon class="mr-2" color="primary">fas fa-quote-left</v-icon> -->
            "{{ help.name }}"
            <!-- <v-icon class="ml-2 mr-2" color="primary">fas fa-quote-right</v-icon> -->
          </blockquote>
          <p class="mt-2 subtitle-2 font-regular">{{ help.author }}</p>
        </div>
        <div v-else>
          <p
            class="headline mb-1 font-weight-bold hover-underlined"
            style="overflow: visible; white-space:normal; line-height: 1.4rem"
          >
            <a :href="help.url" target="_blank">{{ help.name }}</a>
          </p>
          <span class="subtitle-2">by {{ help.author }}</span>
        </div>
        <p
          v-if="help.type !== 'quote'"
          class="py-2 body-1"
          style="overflow: visible; white-space:normal"
        >
          {{ help.description }}
        </p>
      </v-card-text>

      <v-card-actions class="px-4">
        <span>{{ help.isRated ? '' : `Rate this ${help.type}` }}</span>
        <v-spacer></v-spacer>
        <span class="overline mr-2 mt-1"
          >({{ (help.rating / help.nRatings).toFixed(2) }})</span
        >
        <v-rating
          :value="help.rating / help.nRatings"
          background-color="secondary"
          color="secondary"
          :readonly="help.isRated"
          dense
          half-increments
          hover
          size="18"
          v-on:input="handleRate"
        ></v-rating>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: ['help'],
  data() {
    return {}
  },

  methods: {
    handleRate(payload) {
      this.$store
        .dispatch('rateItem', {id: this.help.id, rate: payload})
        .then(res => {
          this.$store.dispatch('showSnackbar', {
            visibility: true,
            text: 'Item rated!',
            icon: 'fas fa-star',
            color: 'secondary',
            textColor: '#ffffff',
            timeout: 4000,
          })
        })
        .catch(err => {})
    },
  },
}
</script>

<style></style>
